import { ref } from 'vue'

export const supportedLocales = ['en', 'ru', 'de', 'fr', 'it'] as const
export type Locale = (typeof supportedLocales)[number]
export const languageNames: Record<Locale, string> = { en: 'English', ru: 'Русский', de: 'Deutsch', fr: 'Français', it: 'Italiano' }
export function resolveLocale(value: string | null | undefined): Locale {
  const code = value?.toLowerCase().split(/[-_]/)[0]
  return supportedLocales.includes(code as Locale) ? (code as Locale) : 'en'
}
export const activeLocale = ref<Locale>('en')
export const getLocale = () => activeLocale.value
